var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Types } from '../../actions/SmartChatActions';
import { initialSmartChatState } from '../../state';
import { BOT_IDENTITY, TIMEOUT_VALUE } from '../../../utils';
export var smartChatReducer = function (state, action) {
    if (state === void 0) { state = initialSmartChatState; }
    switch (action.type) {
        case Types.NEW_MESSAGE:
            return __assign(__assign({}, state), { messages: __spreadArray(__spreadArray([], state.messages, true), [action.payload], false) });
        case Types.CLEAR_MESSAGE:
            return __assign(__assign({}, state), { messages: [action.payload] });
        case Types.RESET_MESSAGE:
            return __assign(__assign({}, state), { messages: [] });
        case Types.PASS_MESSAGE_TO_BOT:
            return __assign(__assign({}, state), { messageToBot: action.payload });
        case Types.UPDATE_PHONE_NUMBER:
            return __assign(__assign({}, state), { phoneNumber: action.payload });
        case Types.UPDATE_EMAIL:
            return __assign(__assign({}, state), { email: action.payload });
        case Types.UPDATE_FIRST_NAME:
            return __assign(__assign({}, state), { firstName: action.payload });
        case Types.UPDATE_CODE:
            return __assign(__assign({}, state), { code: action.payload });
        case Types.IS_TIMEDOUT:
            return __assign(__assign({}, state), { isTimedout: action.payload });
        case Types.START_TIMEOUT:
        case Types.RESET_TIMEOUT:
            return __assign(__assign({}, state), { timerValue: TIMEOUT_VALUE });
        case Types.UPDATE_TIMEOUT:
            return __assign(__assign({}, state), { timerValue: state.timerValue - 1 });
        case Types.START_BOT_TYPING:
            return __assign(__assign({}, state), { members: state.members.map(function (member) {
                    return member.identity === BOT_IDENTITY ? __assign(__assign({}, member), { isTyping: true }) : member;
                }) });
        case Types.STOP_BOT_TYPING:
            return __assign(__assign({}, state), { members: state.members.map(function (member) {
                    return member.identity === BOT_IDENTITY ? __assign(__assign({}, member), { isTyping: false }) : member;
                }) });
        case Types.SHOW_SEND_CODE_ACTION:
            return __assign(__assign({}, state), { showSendCodeAction: true, isTimedout: false });
        case Types.HIDE_SEND_CODE_ACTION:
            return __assign(__assign({}, state), { showSendCodeAction: false });
        case Types.SHOW_CHANGE_PHONE_ACTION:
            return __assign(__assign({}, state), { showChangePhoneAction: true, isTimedout: false });
        case Types.HIDE_CHANGE_PHONE_ACTION:
            return __assign(__assign({}, state), { showChangePhoneAction: false });
        case Types.SHOW_CONTANT_US:
            return __assign(__assign({}, state), { contactUs: true });
        case Types.HIDE_CONTANT_US:
            return __assign(__assign({}, state), { contactUs: false });
        case Types.NEXT_SMART_STATE:
            return __assign(__assign({}, state), { checkpoint: action.payload });
        case Types.NEXT_EXPERIMENT_ONE_SMART_STATE:
            return __assign(__assign({}, state), { experimentCheckpoint: action.payload });
        case Types.SET_PREVIOUS_CHECKPOINT_BEFORE_ERROR:
            return __assign(__assign({}, state), { previousCheckpoint: state.checkpoint });
        case Types.SHOW_FATAL_ERROR_PAGE:
            return __assign(__assign({}, state), { isFatalError: true });
        case Types.HIDE_FATAL_ERROR_PAGE:
            return __assign(__assign({}, state), { isFatalError: false });
        case Types.SAVE_LEADS:
            return __assign(__assign({}, state), { leadId: action.payload });
        case Types.SIGN_IN_SUBMITTED:
            return __assign(__assign({}, state), { signInSubmitted: action.payload });
        case Types.START_STEP_BUTTON_CLICKED:
            return __assign(__assign({}, state), { startStepButtonClicked: action.payload });
        default:
            return state;
    }
};
//# sourceMappingURL=index.js.map